(function () {
function applySubscriptionRules() {
document.querySelectorAll('#header-cart .minicart-prd').forEach(function(item){
const planEl = item.querySelector('.prd-prepay-text');
if (!planEl) {
item.querySelectorAll('.prd-quantity-down').forEach(btn => {
btn.disabled = false;
btn.style.pointerEvents = '';
btn.style.opacity = '';
});
return;}
const planText = planEl.textContent.trim().toLowerCase();
let minQty = 1;

if (planText.includes('3x')) {
minQty = 3;
} else if (planText.includes('6x')) {
minQty = 6;
} else if (planText.includes('1 x') || planText.includes('1x')) {
minQty = 1;
}
const input = item.querySelector('input[name="updates[]"]');
const minusBtn = item.querySelector('.prd-quantity-down');
if (!input || !minusBtn) return;
if (parseInt(input.value) < minQty) {
input.value = minQty;
input.dispatchEvent(new Event('change', { bubbles:true }));
}
input.min = minQty;
function updateMinusState() {
const qty = parseInt(input.value) || minQty;

if (qty <= minQty) {
minusBtn.disabled = true;
minusBtn.style.pointerEvents = 'none';
minusBtn.style.opacity = '0.4';
} else {
minusBtn.disabled = false;
minusBtn.style.pointerEvents = '';
minusBtn.style.opacity = '';
}}
updateMinusState();
input.addEventListener('input', updateMinusState);
input.addEventListener('change', updateMinusState);

});}
document.addEventListener('DOMContentLoaded', applySubscriptionRules);
const observer = new MutationObserver(applySubscriptionRules);
observer.observe(document.body, {
childList: true,
subtree: true
});
})();